export const generateUrl = ( arr = [], keywords = '' ) => {
	const url = [];
	arr.forEach( item => {
		switch ( arr.indexOf( item ) ) {
				case 0:
					if ( 0 < arr[0].length ) {
						const locations = [];
						item.forEach( query => {
							locations.push( encodeURIComponent( query ) );
						} );
						url.push( `locations=${locations.join( '|' )}` );
					}
					break;
				case 1:
					if ( 0 < arr[1].length ) {
						const project_types = [];
						item.forEach( query => {
							project_types.push( encodeURIComponent( query ) );
						} );
						url.push( `projectTypes=${project_types.join( '|' )}` );
					}
					break;
				case 2:
					if ( 0 < arr[2].length ) {
						const services = [];
						item.forEach( query => {
							services.push( encodeURIComponent( query ) );
						} );
						url.push( `services=${services.join( '|' )}` );
					}
					break;
				case 3:
					if ( 0 < arr[3].length ) {
						const contentTypes = [];
						item.forEach( query => {
							contentTypes.push( encodeURIComponent( query ) );
						} );
						url.push( `contentTypes=${contentTypes.join( '|' )}` );
					}
					break;
				default:
					break;
		}
	} );
	if ( 0 < keywords.length ) {
		url.push( `keywords=${encodeURIComponent( keywords )}` );
	}
	return `?${url.join( '&' )}`;
};

export const updateUrl = ( filters, keywords ) => {
	const url = generateUrl( filters, keywords );

	if ( '?' !== url ) {
		window.history.replaceState( null, '', url );
	} else {
		// clear the filters because there are no search terms

		const { location } = window;
		const clearedUrl = `${location.origin}${location.pathname}`;

		// if we aren't already cleared, nows the time to clear the search url
		if ( location.href !== clearedUrl ) {
			window.history.pushState( null, document.title, clearedUrl );
		}
	}
};

export const getQueryValues = location => {
	const searchQuery = location.search;
	return getQueryStringParams( searchQuery );
};

export const getUrlFilters = ( location, filters ) => {
	const values = getQueryValues( location );
	return Object.keys( filters ).map( filter => {
		return values[filter] ? values[filter].split( '|' ) : [];
	} );
};

export const getQueryStringParams = query => {
	return query
		? ( /^[?#]/.test( query ) ? query.slice( 1 ) : query )
			.split( '&' )
			.reduce( ( params, param ) => {
				const [key, value] = param.split( '=' );
				params[key] = value
					? decodeURIComponent( value.replace( /\+/g, ' ' ) )
					: '';
				return params;
			}, {} )
		: {};
};

export const hasTimePeriodElapsed = ( lastSearch, period = 300000 ) => {
	if ( 'number' !== typeof period ) return true;
	const lastSearchTime = parseInt( lastSearch.time ) || 0;
	if ( Date.now() - lastSearchTime > period ) return true;
	return false;
};

export const doSearchParametersDiffer = ( lastSuccessfulSearch, currentSearch ) => {
	if ( lastSuccessfulSearch.searchInputValue !== currentSearch.searchInputValue ) return true;
	if ( JSON.stringify( lastSuccessfulSearch.selectedFilters ) !== JSON.stringify( currentSearch.selectedFilters ) ) return true;
	return false;
};
